(() => {
  document.querySelectorAll('[data-hs-accordion]').forEach((accordion) => {
    accordion.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        accordion.querySelectorAll('details').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  });

  document.querySelectorAll('[data-hs-product]').forEach((root) => {
    const form = root.querySelector('[data-hs-form]');
    if (!form) return;
    const configNode = root.querySelector('[data-hs-config]');
    const config = configNode ? JSON.parse(configNode.textContent) : { directCheckout: true, root: '/', currency: 'USD' };
    const variantInput = form.querySelector('[data-hs-variant-id]');
    const variantSelect = form.querySelector('[data-hs-variant-select]');
    const price = root.querySelector('[data-hs-price]');
    const compare = root.querySelector('[data-hs-compare]');
    const compareWrap = root.querySelector('[data-hs-compare-wrap]');
    const submit = root.querySelector('[data-hs-submit]');
    const submitLabel = root.querySelector('[data-hs-submit-label]');
    const error = root.querySelector('[data-hs-error]');
    const mainImage = root.querySelector('.hs-offer__media > img');
    const compareByVariant = new Map();

    const money = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(Number(cents));
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: config.currency }).format(Number(cents) / 100);
    };

    const changeImage = (source) => {
      if (!source || !mainImage) return;
      mainImage.src = source;
      mainImage.srcset = '';
    };

    const renderComparePrice = (comparePrice) => {
      if (!compare || !compareWrap) return;
      if (Number(comparePrice) > 0) {
        compare.textContent = money(comparePrice);
        compareWrap.hidden = false;
      } else {
        compare.textContent = '';
        compareWrap.hidden = true;
      }
    };

    const hydrateComparePrices = async () => {
      if (!config.productHandle || !compare || !compareWrap) return;
      try {
        const productUrl = `${config.root}products/${encodeURIComponent(config.productHandle)}.js`;
        const response = await fetch(productUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const productData = await response.json();
        (productData.variants || []).forEach((variant) => {
          compareByVariant.set(String(variant.id), Number(variant.compare_at_price || 0));
        });
        const selectedCompare = compareByVariant.get(String(variantInput.value)) || Number(productData.compare_at_price_max || 0);
        renderComparePrice(selectedCompare);
      } catch (_issue) {
        // Keep the server-rendered price when Shopify's JSON endpoint is unavailable.
      }
    };

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      variantInput.value = option.value;
      price.textContent = money(option.dataset.price);
      const comparePrice = Number(option.dataset.compare || 0) || compareByVariant.get(String(option.value)) || 0;
      renderComparePrice(comparePrice);
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submitLabel.textContent = available ? 'GET YOURS 50% OFF' : 'SOLD OUT';
      changeImage(option.dataset.image);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });

    root.querySelectorAll('[data-hs-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => changeImage(thumb.dataset.image));
    });

    hydrateComparePrices();

    form.addEventListener('submit', async (event) => {
      if (!config.directCheckout) return;
      event.preventDefault();
      if (!variantInput.value || submit.disabled) return;
      error.hidden = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitLabel.textContent = 'ADDING…';
      try {
        const response = await fetch(`${config.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantInput.value), quantity: 1 })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This selection could not be added.');
        window.location.assign(`${config.root}checkout`);
      } catch (issue) {
        error.textContent = issue.message || 'Something went wrong. Please try again.';
        error.hidden = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submitLabel.textContent = 'GET YOURS 50% OFF';
      }
    });
  });
})();
